import { createComponentModifiers } from '@ui-system/modifiers';

const componentModifiers = createComponentModifiers(() => ({}));

export default componentModifiers;
